/**
 * railList.tsx
 */
import CircularRail from './circularRail';
import DefaultRail from './defaultRail';
import MainContext from '@shared/components/utils/context/mainContext';
import { memo, useContext } from 'react';

function RailList() {
  const { rails } = useContext(MainContext);
  return (
    <>
      {rails
        ?.filter((rail) => !!rail.data?.length)
        .map((rail) => {
          const Rail = rail.circular ? CircularRail : DefaultRail;
          return <Rail key={rail.id} rail={rail} />;
        })}
    </>
  );
}

export default memo(RailList);
